export enum DraggingMode {
    TOUCH,
    POINTER
}